import { transformRouteNameToRoutePath } from '@/utils';
import { transformAuthRouteToVueRoutes } from '@/utils/router/transform';
import type { App } from "vue";
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { createRouterGuard } from './guard';
import { constantRoutes } from './routes';

const { VITE_HASH_ROUTE = 'N' } = import.meta.env;
// Impact Coolify builds often omit VITE_BASE_URL; vue-router then gets
// createWebHistory(undefined) and crashes on `.split` → blank page.
const routerBase = import.meta.env.VITE_BASE_URL || import.meta.env.BASE_URL || '/';

export const router = createRouter({
  history: VITE_HASH_ROUTE === 'Y' ? createWebHashHistory(routerBase) : createWebHistory(routerBase),
  routes: transformAuthRouteToVueRoutes(constantRoutes),
});

export const routeName = (key: AuthRoute.AllRouteKey) => key;
export const routePath = (key: Exclude<AuthRoute.AllRouteKey, 'not-found'>) => transformRouteNameToRoutePath(key);

export async function setupRouter(app: App) {
  app.use(router);
  createRouterGuard(router);
  await router.isReady();
}

export * from './modules';
export * from './routes';

